import { pxToEm } from 'util/pxToEm';
import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { StarRating, FormErrors } from 'components/ui';
import { FeedbackFormData, RATING_LABELS } from '../constants';

export interface RatingSectionProps {
  control: Control<FeedbackFormData>;
  errors: FieldErrors<FeedbackFormData>;
  readOnly?: boolean;
}

export const RatingSection = ({
  control,
  errors,
  readOnly = false,
}: RatingSectionProps): ReactElement => {
  return (
    <Box mb={40}>
      <Typography
        sx={{
          fontSize: pxToEm(16),
          fontWeight: 500,
          mb: 8,
          color: '#383838',
        }}
      >
        Rate the event
      </Typography>
      <Controller
        name="rating"
        control={control}
        render={({ field }) => (
          <StarRating
            value={field.value}
            onChange={readOnly ? undefined : field.onChange}
            size={30}
            labels={RATING_LABELS}
            showLabels={true}
            readOnly={readOnly}
          />
        )}
      />
      {!readOnly && errors.rating && (
        <FormErrors sx={{ mt: 8 }}>Please provide a rating</FormErrors>
      )}
    </Box>
  );
};

